import {
    LayoutDashboard,
    Database,
    //CreditCard,
    Users,
    BarChart,
    MessageSquare,
    FileText,
    HelpCircle,
    StickyNote,
    Package
} from 'lucide-react';

// Menu Configuration
export const MENU_ITEMS = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
    {
        id: 'master-data',
        label: 'Master Data',
        icon: Database,
        subItems: [
            //{ id: 'card-list', label: 'Card List', icon: CreditCard },
            { id: 'note-list', label: 'Note List', icon: StickyNote },
            { id: 'product-management', label: 'Product Management', icon: Package },
            { id: 'master-user', label: 'Master User', icon: Users }
        ]
    },
    { id: 'analytics', label: 'Analytics', icon: BarChart },
    { id: 'messages', label: 'Messages', icon: MessageSquare },
    { id: 'reports', label: 'Reports', icon: FileText },
    { id: 'help', label: 'Help', icon: HelpCircle },
];
